module.exports = __webpack_public_path__ + "scripts/icons.eot?e2675a61";


//////////////////
// WEBPACK FOOTER
// ./semantic/dist/themes/default/assets/fonts/icons.eot
// module id = 702
// module chunks = 1